import React from 'react';
import { SmallBodyText, TextField } from '../../../../../ui-toolkit';
import { SummaryItemWithEdit } from '../../../../shared/Summary/SummaryItem/SummaryItemWithEdit';
import { useUpdateOrderFromSummaryItem } from '../hooks/useUpdateOrderFromSummaryItem';

export const TransactionID: React.FC = () => {
  const { order, onPatchOrderInformation } = useUpdateOrderFromSummaryItem();
  return (
    <SummaryItemWithEdit
      label={'Transaction ID'}
      tab={`summary`}
      field={`external_party_transaction_id`}
      onUpdate={(_, value) => onPatchOrderInformation({ externalPartyTransactionId: value ?? null })}
      order={order}
      editControl={TextField}
      editProps={{ placeholder: 'abcdefg123456' }}
    >
      {order.transaction.external_party_transaction_id ?? <SmallBodyText intent={`faded`}>-</SmallBodyText>}
    </SummaryItemWithEdit>
  );
};
